import { render, staticRenderFns } from "./signUpDialog.vue?vue&type=template&id=0772b936&scoped=true&"
import script from "./signUpDialog.vue?vue&type=script&lang=js&"
export * from "./signUpDialog.vue?vue&type=script&lang=js&"
import style0 from "./signUpDialog.vue?vue&type=style&index=0&id=0772b936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0772b936",
  null
  
)

export default component.exports